import { render } from "./FlashCardsScreen.vue?vue&type=template&id=312921ca&scoped=true"
import script from "./FlashCardsScreen.vue?vue&type=script&lang=js"
export * from "./FlashCardsScreen.vue?vue&type=script&lang=js"

import "./FlashCardsScreen.vue?vue&type=style&index=0&id=312921ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312921ca"]])

export default __exports__